import { shuffleResults } from '../helpers/common'
import { expertsFiltersMessages as messages,
  expertsFiltersDropdownMessages as dropdownMessages,
  tagFiltersMessages } from './messages'

/**
 * @param {array} results the results coming for the prof. request
 * @returns {array} ordered with a custom rule first experts verified
 * then office and last unverified experts
 */

export const orderingResults = results => {
  if (!results?.length) {
    return []
  }
  results = shuffleResults(results)
  const expertsVerified = []
  const offices = []
  const expertsUnverified = []
  results.forEach(val => {
    if (val.type === 'expert' && val.verified) {
      expertsVerified.push(val)
    } else if (val.type === 'expert' && !val.verified) {
      expertsUnverified.push(val)
    } else if (val.type === 'office') {
      offices.push(val)
    }
  })
  return [ ...expertsVerified, ...offices, ...expertsUnverified ]
}

const translateFilter = (item, messages, intl) => {
  const slugsToTranslate = Object.keys(messages)
  try {
    if (slugsToTranslate.includes(item.slug)) {
      item.name = intl.formatMessage({ ...messages[item.slug] })
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error translating key', item.slug, messages)
  }

  if (item.sub_categories?.length) {
    item.sub_categories.map(item => translateFilter(item, messages, intl))
  }

  return item
}

/**
 * Returns filter's object with custom translation
 * @param {object} filters
 * @param {object} intl object type intl
 * @returns object filters
 */
export const translateExpertiseFilters = (filters, intl) => {
  const { expertise = [], expertise_1: expertise1 = [], expertise_tree: expertiseTree = [] } = filters

  const translatedExpertise = expertise.map(item => translateFilter(item, messages, intl))
  const translatedExpertise1 = expertise1.map(item => translateFilter(item, messages, intl))
  const translatedExpertiseTree = expertiseTree.map(item => translateFilter(item, dropdownMessages, intl))

  return {
    ...filters,
    expertise: translatedExpertise,
    expertise_1: translatedExpertise1,
    expertiseTree: translatedExpertiseTree
  }
}

/**
 * Returns filter's object with custom translation
 * @param {object} filters
 * @param {object} intl object type intl
 * @returns object filters
 */
export const translateTagFilters = (filters, intl) => {
  const { tag_tree: tagTree } = filters

  const translatedTagTopics = tagTree.map(item => translateFilter(item, tagFiltersMessages, intl))

  return {
    ...filters,
    tag_tree: translatedTagTopics
  }
}
